import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { LockIcon, ClockIcon, SmartphoneIcon } from 'lucide-react';
export function CTASection() {
  return <section id="precio" className="bg-navy text-white py-20 md:py-32 relative overflow-hidden" data-id="element-21">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/10 via-navy to-navy pointer-events-none" data-id="element-22" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-24">
          <div className="inline-block px-4 py-1.5 rounded-full border border-red-500/30 bg-red-500/10 text-red-400 text-sm font-semibold tracking-wide mb-8 animate-pulse" data-id="element-25">
            ⏳ Oferta disponible por tiempo limitado
          </div>

          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-26">
            Empieza hoy con <span className="text-gold" data-id="element-27">IA Exprés 2026</span>
          </h2>

          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-28">
            No vende teoría. Vende una forma simple, actual y accesible de
            empezar algo tuyo.
          </p>

          <div id="acceso" className="bg-navy-dark/80 border border-gold/20 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto backdrop-blur-md shadow-2xl shadow-gold/5" data-id="element-29">
            <img src="https://cdn.magicpatterns.com/uploads/4EhZYLC9XTmbCGKjZV8qW8/IA_Expres_3_mini_negocios.png" alt="IA Exprés 2026" className="w-48 md:w-64 mx-auto rounded-xl shadow-lg mb-8 border border-white/10" data-id="element-30" />

            <div className="mb-8" data-id="element-31">
              <span className="text-lg text-gray-500 line-through mr-3" data-id="element-32">
                $47 USD
              </span>
              <div className="mt-2" data-id="element-33">
                <span className="text-5xl font-bold text-white" data-id="element-34">$6.39</span>
                <span className="text-xl text-gold ml-2 font-medium" data-id="element-35">USD</span>
              </div>
              <span className="inline-block mt-3 px-3 py-1 rounded-full bg-green-500/20 text-green-400 text-sm font-semibold" data-id="element-36">
                🔥 Descuento por lanzamiento — Ahorra 86%
              </span>
            </div>

            <CTAButton href="https://iaexpres2026.com/cart/46518835478718:1" className="w-full text-xl py-5 mb-8" data-id="element-37">
              QUIERO MI ACCESO AHORA
            </CTAButton>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-gray-400" data-id="element-38">
              <div className="flex items-center gap-2" data-id="element-39">
                <LockIcon className="w-4 h-4 text-gold" data-id="element-40" />
                <span data-id="element-41">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-42">
                <SmartphoneIcon className="w-4 h-4 text-gold" data-id="element-43" />
                <span data-id="element-44">Desde tu celular</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-45">
                <ClockIcon className="w-4 h-4 text-gold" data-id="element-46" />
                <span data-id="element-47">Sin complicaciones</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}